document.addEventListener("DOMContentLoaded", async function () {
  const selectedCityEl = document.querySelector("#selected-city");
  if (!selectedCityEl) {
    return;
  }
  let deliveryInfo = sessionStorage.getItem(getDeliveryInfoKey());
  let is_todaySDate = '';
  let slotTextEle = document.querySelector(`.select-time-slot-btn[data-target="#selectDeliveryModal"] .select-time-slot-text`);
  if (deliveryInfo) {
    deliveryInfo = JSON.parse(deliveryInfo);
    if (deliveryInfo && deliveryInfo.time === '60-90' && !isExpressEligible()) {
      deliveryInfo.time = 'standard';
      deliveryInfo.time_slot = '';
      sessionStorage.setItem(getDeliveryInfoKey(), JSON.stringify(deliveryInfo));
    }
  }
  let selectedCity = document.querySelector("#selected-city").value;

  if (deliveryInfo && deliveryInfo?.city) {
    selectedCity = deliveryInfo.city;
    if (deliveryInfo.pin) {
      const pincodeEle = document.querySelector('#app-pincode');

      if (pincodeEle) {
        pincodeEle.value = deliveryInfo.pin;

        pincodeEle.dispatchEvent(new Event('input', { bubbles: true }));
        pincodeEle.dispatchEvent(new Event('keyup', { bubbles: true }));
        pincodeEle.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (deliveryInfo.date && deliveryInfo.time_slot) {
      const dateObj = new Date(deliveryInfo.date);
      dateObj.setHours(0, 0, 0, 0);
      const formattedDate = dateObj.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
      const selectedSessionSlotData = formattedDate + ' · ' + deliveryInfo.time_slot;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const todayStr = today.getFullYear() + '-' +
        String(today.getMonth() + 1).padStart(2, '0') + '-' +
        String(today.getDate()).padStart(2, '0');


      if (deliveryInfo.date === todayStr) {
        console.log('formattedDate is today:', formattedDate);
        is_todaySDate = true;
      } else {
        console.log('formattedDate is not today:', formattedDate);
        is_todaySDate = false;
      }

      if (slotTextEle && dateObj.getTime() >= today.getTime()) {
        slotTextEle.innerText = selectedSessionSlotData;
      }

    }
  } else {
    selectedCity = document.querySelector("#selected-city").value;
  }
  if (!fixeListWithCoff[selectedCity]) {
    selectedCity = document.querySelector("#selected-city").value;
  }
  const deliveryCutoffTime = fixeListWithCoff[selectedCity].at(-1).cutoff_time;
  const todayEndDelivery = getRemainingTime(deliveryCutoffTime.replace(/\s+/g, ''));
  const sameDayTimeEl = document.querySelector(`.same-day-delivery .same-day-delivery-time`);
  if (sameDayTimeEl) {
    sameDayTimeEl.innerText = 'Order in ' + todayEndDelivery;
  }
  const today = new Date();

  const tomorrow = new Date();
  const dayAfterTomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);
  dayAfterTomorrow.setDate(today.getDate() + 2);


  if (todayEndDelivery == '00h 00m' && document.body.dataset.template?.includes('inter-city')) {
    document.querySelector(`.delivery-badge-text`).innerText = 'Free Delivery';
    document.querySelector(`.same-day-delivery`).classList.remove('show');
  } else if (todayEndDelivery != '00h 00m' && document.body.dataset.template?.includes('inter-city')) {
    document.querySelector(`.same-day-delivery`).classList.add('show');

  }

  let todayDateEle = document.querySelector(`.select-data-wrap .today_date_wrap div`);
  let tomorrowDateEle = document.querySelector(`.select-data-wrap .tomorrow_date_wrap div`);

  let isInterCityPopup = document.querySelector('.intercity-select-data-wrap');
  let dayAfterTomorrowDateEle = document.querySelector(`.intercity-select-data-wrap .day_after_tomorrow_date_wrap div`);
  setupDeliveryDateLabels(document);
  autoSelectDeliveryDateTime(document, todayEndDelivery);
});

// const modal = document.getElementById("customModal");
document.addEventListener("click", function (e) {
  const scopeEl = e.target.closest('#quickViewModal') || document;

  if (e.target.classList.contains("open-modal")) {
    const modalTarget = e.target.getAttribute("data-target")?.replace('#', '');
    const targetModal = scopeEl.querySelector(`#${modalTarget}`);
    if (targetModal) targetModal.style.display = "flex";
    document.body.classList.add("custom-model-open");

    if (e.target.classList.contains("select-time-slot-btn")) {
      jQuery(e.target).removeClass('error');
    }
  }

  if (e.target.classList.contains("modal-message-add-btn")) {
    let messageText = scopeEl.querySelector("textarea#personal_message").value.trim();
    if (messageText == '') {
      messageText = 'Add a complimentary message card';
      scopeEl.querySelector('.message-add').style.display = "block";
    } else {
      scopeEl.querySelector('.message-add').style.display = "none";
    }
    scopeEl.querySelector(".personal-message-btn-wrap .personal-message-btn").innerText = messageText;
    scopeEl.querySelector('#personalMessageModal').style.display = "none";
    document.body.classList.remove("custom-model-open");
  }

  if (e.target.classList.contains("modal-select-delivery-btn")) {
    var isValid = true;

    // Elements — scoped to the modal's own product form
    var $pincode = jQuery(scopeEl).find('.main-product-form .app-pincode');
    var $datepicker = jQuery(scopeEl).find('.main-product-form .app-form-group__datepicker-input').last();
    var $timeSlot = jQuery(scopeEl).find('.main-product-form .app-time-subscription');

    $pincode.removeClass('error');
    $datepicker.removeClass('error');
    $timeSlot.removeClass('error');

    let slotType = jQuery(scopeEl).find('.main-product-form [name="properties[_slot]"]:checked').val();

    if ($pincode.val().trim() === '') {
      $pincode.addClass('error');
      isValid = false;
    }

    if ($datepicker.length > 0 && $datepicker.val().trim() === '') {
      $datepicker.addClass('error');
      isValid = false;
    }

    if (slotType !== '60-90') {
      if ($timeSlot.length > 0 && ($timeSlot.val().trim() === '' || $timeSlot.val() === ' ')) {
        $timeSlot.addClass('error');
        isValid = false;
      }
    }

    if (isValid) {
      let selectedCity = scopeEl.querySelector("#selected-city")?.value;
      let timeVal = (slotType === '60-90') ? 'Express Delivery' : jQuery(scopeEl).find('#app-time-subscription').last().val();
      let selectedDateSlot = getDateStatus($datepicker.val()) + ' · ' + timeVal;

      scopeEl.querySelector(`.select-time-slot-btn[data-target="#selectDeliveryModal"] .select-time-slot-text`).innerText = selectedDateSlot;
      scopeEl.querySelector('#selectDeliveryModal').style.display = "none";
      document.body.classList.remove("custom-model-open");
    }

    let timeSlotVal = (slotType === '60-90') ? 'Express Delivery' : scopeEl.querySelector('#app-time-subscription')?.value.trim();

    updateDeliveryInfo("city", scopeEl.querySelector('#selected-city')?.value);
    updateDeliveryInfo("pin", scopeEl.querySelector('#app-pincode')?.value);
    updateDeliveryInfo("date", scopeEl.querySelector('#app-date-subscription')?.value);
    updateDeliveryInfo("time", slotType);
    updateDeliveryInfo("time_slot", timeSlotVal);
  }

  if (e.target.classList.contains("close-model")) {
    const modalCloseTarget = e.target.getAttribute("data-target")?.replace('#', '');
    const targetModal = scopeEl.querySelector(`#${modalCloseTarget}`);
    if (targetModal) targetModal.style.display = "none";
    document.body.classList.remove("custom-model-open");

    let closeSlotType = scopeEl.querySelector('[name="properties[_slot]"]:checked')?.value;
    let closeTimeSlotVal = (closeSlotType === '60-90') ? 'Express Delivery' : scopeEl.querySelector('#app-time-subscription')?.value.trim();

    updateDeliveryInfo("city", scopeEl.querySelector('#selected-city')?.value);
    updateDeliveryInfo("pin", scopeEl.querySelector('#app-pincode')?.value);
    updateDeliveryInfo("date", scopeEl.querySelector('#app-date-subscription')?.value);
    updateDeliveryInfo("time", closeSlotType);
    updateDeliveryInfo("time_slot", closeTimeSlotVal);
  }
});

// format function
function formatDate(d) {
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
}
function formatDateDayMonth(date) {
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
}
function getDateStatus(dateString) {
  const inputDate = new Date(dateString);

  // Normalize time (important for correct comparison)
  inputDate.setHours(0, 0, 0, 0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  if (inputDate.getTime() === today.getTime()) {
    return "Today, " + formatDate(inputDate);;
  }

  if (inputDate.getTime() === tomorrow.getTime()) {
    return "Tomorrow, " + formatDate(inputDate);;
  }

  if (inputDate > tomorrow) {
    return formatDate(inputDate);
  }

  return "past date";
}

function getRemainingTime(inputTime) {
  const now = new Date();

  function parseTime(timeStr) {
    timeStr = timeStr.trim().toUpperCase();

    let hours, minutes = 0;

    // Case: "9PM", "11:30 AM"
    const ampmMatch = timeStr.match(/(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/);
    if (ampmMatch) {
      hours = parseInt(ampmMatch[1], 10);
      minutes = parseInt(ampmMatch[2] || "0", 10);

      const period = ampmMatch[3];

      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;

      return { hours, minutes };
    }

    // Case: "21:00"
    const normalMatch = timeStr.match(/(\d{1,2}):(\d{2})/);
    if (normalMatch) {
      return {
        hours: parseInt(normalMatch[1], 10),
        minutes: parseInt(normalMatch[2], 10)
      };
    }

    throw new Error("Invalid time format");
  }

  const { hours, minutes } = parseTime(inputTime);

  const target = new Date();
  target.setHours(hours, minutes, 0, 0);

  let diff = target - now;

  // ❗ If time already passed → return 00
  if (diff <= 0) {
    return "00h 00m";
  }

  const h = Math.floor(diff / (1000 * 60 * 60));
  const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

  return `${h}h ${m}m`;
}

function minusMin(timeStr, minusMin) {
  const date = new Date(`2000-01-01 ${timeStr}`);
  date.setMinutes(date.getMinutes() - 30);

  let hours = date.getHours();
  let minutes = date.getMinutes();

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return `${hours}:${minutes.toString().padStart(2, "0")}${ampm}`;
}

function getDeliveryInfoKey() {
  const isInterCity = document.body.dataset.template?.includes('inter-city');
  return isInterCity ? "delivery_info_intercity" : "delivery_info_non_intercity";
}
function updateDeliveryInfo(key, value) {
  const storageKey = getDeliveryInfoKey();

  // Get old data
  const oldData = JSON.parse(
    sessionStorage.getItem(storageKey)
  ) || {};

  // Update field
  oldData[key] = value;

  // Save updated data
  sessionStorage.setItem(
    storageKey,
    JSON.stringify(oldData)
  );

  return oldData;
}

function applyDeliveryInfo(deliveryInfo) {
  // 1. Set city
  const cityEle = document.querySelector("#selected-city");
  if (cityEle && deliveryInfo.city) {
    cityEle.value = deliveryInfo.city;
    cityEle.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // 2. Set pincode
  if (deliveryInfo.pin) {
    const pincodeEle = document.querySelector('#app-pincode');

    if (pincodeEle) {
      pincodeEle.value = deliveryInfo.pin;

      pincodeEle.dispatchEvent(new Event('input', { bubbles: true }));
      pincodeEle.dispatchEvent(new Event('keyup', { bubbles: true }));
      pincodeEle.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // 3. Wait until flatpickr element available
  if (deliveryInfo.date) {
    const dateInterval = setInterval(() => {
      const dateEle = document.querySelector('.app-form-group__datepicker-input');

      if (dateEle && dateEle._flatpickr) {
        clearInterval(dateInterval);

        let todayDateEle = document.querySelector(`.select-data-wrap .today_date_wrap div`);
        let tomorrowDateEle = document.querySelector(`.select-data-wrap .tomorrow_date_wrap div`);
        let todayDateEleValue = todayDateEle.dataset.date;
        let tomorrowDateEleValue = tomorrowDateEle.dataset.date;
        if (deliveryInfo.date == todayDateEleValue) {
          todayDateEle.click();
        } else if (deliveryInfo.date == tomorrowDateEleValue) {
          tomorrowDateEle.click();
        }

        dateEle._flatpickr.setDate(deliveryInfo.date, true);

        dateEle.dispatchEvent(new Event('change', { bubbles: true }));

        // 4. Set time slot radio
        setTimeout(() => {
          if (deliveryInfo.time) {
            let timeVal = deliveryInfo.time;
            if (timeVal === '60-90' && !isExpressEligible()) {
              timeVal = 'standard';
              deliveryInfo.time_slot = '';
            }

            const timeEle = document.querySelector(
              `[name="properties[_slot]"][value="${timeVal}"]`
            );

            if (timeEle) {
              timeEle.checked = true;

              timeEle.dispatchEvent(new Event('change', { bubbles: true }));
            }

          }

          // 5. Set subscription time
          setTimeout(() => {
            const subEle = document.querySelector('#app-time-subscription');
            if (subEle) {
              if (deliveryInfo.time === '60-90' && !isExpressEligible()) {
                const firstValidOption = [...subEle.options].find(opt => opt.value.trim() !== '');
                if (firstValidOption) {
                  subEle.value = firstValidOption.value;
                  subEle.dispatchEvent(new Event('change', { bubbles: true }));

                  let selectedCookieDateSlot = getDateStatus(deliveryInfo.date) + ' · ' + firstValidOption.value;
                  const slotTextBtn = document.querySelector(`.select-time-slot-btn[data-target="#selectDeliveryModal"] .select-time-slot-text`);
                  if (slotTextBtn) slotTextBtn.innerText = selectedCookieDateSlot;
                }
                return;
              }

              if (deliveryInfo.time_slot) {
                subEle.value = deliveryInfo.time_slot;

                subEle.dispatchEvent(new Event('change', { bubbles: true }));

                let selectedCookieDateSlot = getDateStatus(deliveryInfo.date) + ' · ' + deliveryInfo.time_slot;
                const slotTextBtn = document.querySelector(`.select-time-slot-btn[data-target="#selectDeliveryModal"] .select-time-slot-text`);
                if (slotTextBtn) slotTextBtn.innerText = selectedCookieDateSlot;
              }
            }
          }, 500);
        }, 200);
      }
    }, 500);
  }
}

function setPersonalMessage(type, clickedEl) {
  const messageMap = {
    msgBirthday: "Happy Birthday! Wishing you joy, success, and beautiful moments ahead.",
    msgAnniversary: "Happy Anniversary! Wishing you both a lifetime of love and happiness.",
    msgSympathy: "Deepest condolences to you and your family during this difficult time."
  };

  const scopeEl = (clickedEl && clickedEl.closest('#personalMessageModal')) || document;
  const textarea = scopeEl.querySelector('textarea#personal_message');
  if (!textarea) return;

  textarea.value = messageMap[type] || "";
}

function isDateDisabledInMetaobject(dateObj, cityData) {
  if (!dateObj || !cityData || !cityData.date_disabled) return false;
  let disabledList = cityData.date_disabled;
  if (typeof disabledList === 'string') {
    disabledList = disabledList.split(',').map(s => s.trim());
  }
  if (!Array.isArray(disabledList)) {
    disabledList = [disabledList];
  }

  const targetYear = dateObj.getFullYear();
  const targetMonth = dateObj.getMonth();
  const targetDate = dateObj.getDate();

  return disabledList.some(d => {
    if (!d) return false;
    const parsed = new Date(d);
    if (isNaN(parsed.getTime())) return false;
    return (
      parsed.getFullYear() === targetYear &&
      parsed.getMonth() === targetMonth &&
      parsed.getDate() === targetDate
    );
  });
}
window.isDateDisabledInMetaobject = isDateDisabledInMetaobject;

function autoSelectDeliveryDateTime(scopeEl, todayEndDelivery) {
  if (window.quickViewSkipAutoSelect) return;
  scopeEl = scopeEl || document;
  todayEndDelivery = todayEndDelivery || '00h 00m';

  const scopedSameDayTimeEl = scopeEl.querySelector('.same-day-delivery .same-day-delivery-time');
  if (scopedSameDayTimeEl) {
    scopedSameDayTimeEl.innerText = 'Order in ' + todayEndDelivery;
  }

  const dateInterval = setInterval(() => {
    const dateEle = scopeEl.querySelector('.app-form-group__datepicker-input');

    if (dateEle && dateEle._flatpickr) {
      clearInterval(dateInterval);

      const fp = dateEle._flatpickr;
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const minDate = new Date(fp.config.minDate);
      minDate.setHours(0, 0, 0, 0);

      const isToday = minDate.getTime() === today.getTime();
      const isInterCityPopup = scopeEl.querySelector('.intercity-select-data-wrap');

      const todayBox = scopeEl.querySelector('.select-data-wrap .today_date_wrap');
      const isTodayDisabled = (typeof fp.isEnabled === 'function' && !fp.isEnabled(today)) || (todayBox && todayBox.classList.contains('disabled'));

      if (todayEndDelivery != '00h 00m' && isToday && !isTodayDisabled) {
        if (isInterCityPopup) {
          scopeEl.querySelector('.select-data-wrap .select-date-box.tomorrow_date_wrap')?.click();
          scopeEl.querySelector('.fixed-slot')?.classList.add('hidden');
        } else {
          scopeEl.querySelector('.same-day-delivery')?.classList.add('show');
          scopeEl.querySelector('.select-data-wrap .today_date_wrap')?.click();
        }
      } else {
        if (isInterCityPopup) {
          scopeEl.querySelector('.select-data-wrap .select-date-box.tomorrow_date_wrap')?.classList.add('disabled');
          scopeEl.querySelector('.intercity-select-data-wrap .day_after_tomorrow_date_wrap div')?.click();
          scopeEl.querySelector('.fixed-slot')?.classList.add('hidden');
        } else {
          scopeEl.querySelector('.select-data-wrap .select-date-box.today_date_wrap')?.classList.add('disabled');
          scopeEl.querySelector('.select-data-wrap .tomorrow_date_wrap')?.click();
        }
      }

      setTimeout(() => {
        const form = scopeEl.querySelector('form');
        if (form && typeof window.check60MinsDelivery === 'function') {
          window.check60MinsDelivery('#' + form.id);
        }

        const timePicker = scopeEl.querySelector('.app-time-picker');
        const isTimePickerVisible = timePicker && timePicker.style.display !== 'none' && getComputedStyle(timePicker).display !== 'none';

        if (!isTimePickerVisible) return;

        const el = scopeEl.querySelector('#app-time-subscription');
        if (!el) return;
        const firstValidOption = [...el.options].find(opt => opt.value.trim() !== '');
        if (firstValidOption) {
          el.value = firstValidOption.value;
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 700);
    }
  }, 500);
}

function setupDeliveryDateLabels(scopeEl) {
  scopeEl = scopeEl || document;

  const today = new Date();
  const tomorrow = new Date();
  const dayAfterTomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);
  dayAfterTomorrow.setDate(today.getDate() + 2);

  const todayDateEle = scopeEl.querySelector('.select-data-wrap .today_date_wrap div');
  const tomorrowDateEle = scopeEl.querySelector('.select-data-wrap .tomorrow_date_wrap div');
  const isInterCityPopup = scopeEl.querySelector('.intercity-select-data-wrap');
  const dayAfterTomorrowDateEle = scopeEl.querySelector('.intercity-select-data-wrap .day_after_tomorrow_date_wrap div');

  if (todayDateEle) {
    todayDateEle.setAttribute('data-date', today.toISOString().split('T')[0]);
    todayDateEle.innerText = formatDateDayMonth(today);
  }
  if (tomorrowDateEle) {
    tomorrowDateEle.setAttribute('data-date', tomorrow.toISOString().split('T')[0]);
    tomorrowDateEle.innerText = formatDateDayMonth(tomorrow);
  }
  if (isInterCityPopup && dayAfterTomorrowDateEle) {
    dayAfterTomorrowDateEle.setAttribute('data-date', dayAfterTomorrow.toISOString().split('T')[0]);
    dayAfterTomorrowDateEle.innerText = formatDateDayMonth(dayAfterTomorrow);
  }
}

function isExpressEligible() {
  const container = document.querySelector('.slot-60-90-container');
  if (!container) return false;

  const inExpressCollection = container.getAttribute('data-in-express-collection') === 'true';
  if (!inExpressCollection) return false;

  const activeCollectionId = container.getAttribute('data-active-collection-id');
  const isExpressCollectionActive = (activeCollectionId === '516141416768');
  const isCartEdit = !!document.getElementById('AddToCartForm-editpopup');
  const isPreview = window.location.search.includes('preview');

  return isExpressCollectionActive || isCartEdit || isPreview;
}
